import React from 'react';
import PaymentForm from './PaymentForm';

const PaymentModal = ({ 
  isOpen, 
  onClose, 
  paymentType, 
  onSuccess, 
  onError,
  userId,
  leagueId 
}) => {
  if (!isOpen) return null;

  const handleSuccess = (paymentIntent) => {
    onSuccess && onSuccess(paymentIntent);
    onClose();
  };

  const handleError = (error) => {
    onError && onError(error);
  };

  const handleCancel = () => {
    onClose();
  };

  const getPaymentTypeInfo = () => {
    switch (paymentType) {
      case 'private_league':
        return {
          title: 'Private League Subscription',
          description: 'Create your own private league and invite friends to compete!'
        };
      default:
        return {
          title: 'Payment',
          description: 'Complete your payment to continue.'
        };
    }
  };

  const paymentInfo = getPaymentTypeInfo();

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 12,
        padding: 32,
        maxWidth: 500,
        width: '90%',
        maxHeight: '90vh',
        overflow: 'auto',
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
      }}>
        <div style={{ marginBottom: 24 }}>
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            marginBottom: 16
          }}>
            <h2 style={{ 
              color: '#2563eb', 
              margin: 0, 
              fontSize: 24, 
              fontWeight: 700 
            }}>
              {paymentInfo.title}
            </h2>
            <button
              onClick={onClose}
              style={{
                background: 'none',
                border: 'none',
                fontSize: 24,
                cursor: 'pointer',
                color: '#6b7280',
                padding: 4,
                borderRadius: 4
              }}
            >
              ×
            </button>
          </div>
          <p style={{ 
            color: '#64748b', 
            margin: 0, 
            fontSize: 16,
            lineHeight: 1.5
          }}>
            {paymentInfo.description}
          </p>
        </div>

        <PaymentForm
          paymentType={paymentType}
          onSuccess={handleSuccess}
          onError={handleError}
          onCancel={handleCancel}
          userId={userId}
          leagueId={leagueId}
        />

        <div style={{ 
          marginTop: 24, 
          padding: 16, 
          background: '#f8fafc', 
          borderRadius: 8,
          fontSize: 14,
          color: '#64748b',
          lineHeight: 1.5
        }}>
          <div style={{ fontWeight: 600, marginBottom: 8, color: '#374151' }}>
            Secure Payment
          </div>
          <div style={{ marginBottom: 8 }}>
            • Your payment information is encrypted and secure
          </div>
          <div style={{ marginBottom: 8 }}>
            • We use Stripe for secure payment processing
          </div>
          <div>
            • You can cancel your subscription at any time
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentModal; 